import { create } from "zustand";
import { useSyncLogs } from "../useSyncLogs";
import { frontDB } from "../../../../../frontDB";
import api from "../../../../../api";

export let useSyncLogsHeader = create((set, get) => ({
  filter: { locationId: "*", saveToOffice: "*" },
  latestSyncLogs: [],
  setSelectedLocation: () => {
    let { location } = frontDB.getState();
    if (!location) {
      set({ filter: { ...get().filter, locationId: "*" } });
      return;
    }

    set({ filter: { ...get().filter, locationId: location._id } });
  },

  locationHandler: (value) => {
    set({ filter: { ...get().filter, locationId: value } });
    useSyncLogs.setState({ activePage: 1 });
  },
  saveToOfficeStatusHandler: (value) => {
    set({ filter: { ...get().filter, saveToOffice: value } });
    useSyncLogs.setState({ activePage: 1 });
  },
  getLatestSyncLogs: async () => {
    let latestSyncLogs = await api.synclogs.getLatestSyncLogs();

    if (latestSyncLogs) {
      set({ latestSyncLogs });
    }
  },
}));
